/**
 * 格式化经纬度，直接截断指定小数位数（不四舍五入）
 * @param {number|string} value - 需要格式化的经纬度值
 * @param {number} decimals - 保留的小数位数，默认保留 8 位
 * @param {boolean} returnString - 是否强制返回字符串（用于 UI 展示时保留末尾的0），默认 false
 * @returns {number|string} 格式化后的经纬度值
 */
export function formatCoordinate(value, decimals = 8, returnString = false) {
  // 1. 异常拦截：如果传入 null、undefined 或空字符串，原样返回并抛出警告
  if (value === null || value === undefined || value === '') {
    console.warn(`[formatCoordinate]: 传入了空的经纬度值 ->`, value);
    return value;
  }

  // 2. 转换为字符串并校验是否为有效数字
  const strValue = String(value);
  if (isNaN(Number(strValue))) {
    console.warn(`[formatCoordinate]: 传入了非数字的经纬度值 ->`, value);
    return value;
  }

  // 3. 核心转换：使用字符串分割法直接截断，避免 JS 浮点数精度计算 BUG
  const parts = strValue.split('.');
  const intPart = parts[0];
  let decimalPart = parts[1] || ''; // 如果没有小数部分，默认为空字符串

  // 通过 padEnd 补齐末尾的 0（如果位数不够），通过 slice 截断（如果位数超了）
  decimalPart = decimalPart.padEnd(decimals, '0').slice(0, decimals);

  // 组合最终的字符串
  const formattedString = decimals > 0 ? `${intPart}.${decimalPart}` : intPart;

  // 4. 类型返回：根据配置决定返回数字还是字符串
  return returnString ? formattedString : Number(formattedString);
}
